module.exports = __webpack_public_path__ + "static/img/r-1-3-icon.dbb5a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/r-1-3-icon.png
// module id = 19st
// module chunks = 0